import React, { useContext, useEffect, useState } from 'react'
import { ContextType } from '../../type/type'
import { Title, WrapperData } from '../../style/style'
import { Col, Empty, Pagination, Row } from 'antd'
import { AppContext } from '../../App'
import { useTranslation } from 'react-i18next'
import { getRequest } from '../../request/request'
import { errors } from '../../function/errors'
import { useLocation, useNavigate } from 'react-router-dom'
import ItemNews from '../../modules/News/ItemNews/ItemNews'
import { formatDate } from '../../function/formatDate'

const ArchiveNews = ({ type }: any) => {
  const { t } = useTranslation()
  const { state } = useContext<ContextType>(AppContext)
  const [data, setData] = useState<[] | null>(null)
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)
  const navigate = useNavigate()
  const objUrl = useLocation()
  const [formatData, setFormatData] = useState<string>('DD.MM.YYYY')

  useEffect(() => {
    setFormatData(formatDate(state.lang))

    let url
    if (objUrl?.search) {
      setCurrent(+objUrl.search.split('?page=')[1])
      url = `/news/${objUrl.search}&page_size=5&news_type=${type}`
    } else {
      url = `/news/?page_size=5&news_type=${type}`
      setCurrent(+1)
    }

    getRequest(url)
      .then((res) => {
        setData(res?.data?.results)
        setTotal(res?.data?.count)
      })
      .catch((err) => {
        errors(err)
      })
  }, [state.lang, current, type])

  const handlePagination = (page: number) => {
    navigate(`/archive-news/?page=${page}`)
    setCurrent(page)
    window.scrollTo(0, 0)
  }
  return (
    <WrapperData className="br-12">
      <Title className="title display-none-mobile">{type === 'woman' ? t('h170') : t('m10')}</Title>

      {data?.length ? (
        type === 'woman' ? (
          <Row gutter={[30, 30]}>
            <ItemNews data={data} col={12} formatData={formatData} />
          </Row>
        ) : (
          <Row gutter={[30, 30]}>
            <Col lg={12}>
              <ItemNews data={data} col={12} formatData={formatData} big />
            </Col>
            <Col lg={12}>
              <Row gutter={[30, 30]}>
                <ItemNews data={data} col={12} start={1} formatData={formatData} />
              </Row>
            </Col>
          </Row>
        )
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
      <br />
      <br />
      <div className="text-center">
        {total >= 5 && (
          <Pagination
            pageSize={5}
            defaultCurrent={current}
            total={total}
            onChange={handlePagination}
            showSizeChanger={false}
          />
        )}
      </div>
    </WrapperData>
  )
}

export default ArchiveNews
